var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("header-view", {
                staticClass: "text-uppercase",
                attrs: { title: _vm.$t("message.info.title") }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c("b-col", [
            _c("p", [
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    href: "https://meine-vertraege.net"
                  }
                },
                [_vm._v("Meine-vertraege.net")]
              ),
              _vm._v(
                " ist ein digitaler Vertragsmanager der es Benutzern erlaubt,\n       seine kompletten Vertragsverhältnisse zu erfassen und aufzulisten. Des Weiteren kann der Kontoinhaber Kontaktpersonen bestimmen, welche nach seinem Ableben Einsicht in die ihnen zugeordneten Verträge gewährt bekommen."
              ),
              _c("br"),
              _vm._v(
                "\n       Der digitale Vertragsmanager wird als Assistancedienstleistung der Bestattungsvorsorgeversicherung von der \n       "
              ),
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    href: "https://www.nuernberger.de/"
                  }
                },
                [_vm._v("NÜRNBERGER VERSICHERUNG")]
              ),
              _vm._v(" in Kooperation mit dem \n       "),
              _c(
                "a",
                {
                  attrs: { target: "_blank", href: "https://www.bestatter.de/" }
                },
                [_vm._v("Kuratorium Deutsche Bestattungskultur")]
              ),
              _vm._v(" angeboten.\n\n     ")
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-5" },
        [
          _c("b-col", [
            _c(
              "a",
              {
                attrs: { target: "_blank", href: "https://www.nuernberger.de" }
              },
              [
                _c("img", {
                  staticClass: "n-logo",
                  attrs: { src: require("@/assets/Nuernberger-logo.png") }
                })
              ]
            ),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: { target: "_blank", href: "https://www.bestatter.de/" }
              },
              [
                _c("img", {
                  staticClass: "b-logo mt-5",
                  attrs: { src: require("@/assets/Bestatter-logo.png") }
                })
              ]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d2edd08", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d2edd08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/InfoText.vue
// module id = SmLK
// module chunks = 1